import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar";

const MentorsAndCommunityLayout = () => {
  return (
    <Sidebar>
      <Outlet />
    </Sidebar>
  );
};

export default MentorsAndCommunityLayout;
